const translations = {
  'careerService.seo.title': 'Help to Find TEFL Jobs in Barcelona | 2025',
  'careerService.seo.description':
    'TEFL Iberia has a unique and dedicated careers service to help our students find good TEFL jobs after graduating. Find out more.',
  'careerService.sec1.title': 'Careers service',
  'careerService.sec2.title': ' Unlock a world of new possibilities',
  'careerService.sec2.description':
    'English language instruction is in high demand across the globe. Among countless other potential career paths, completing your Trinity CertTESOL course allows you to:',
  'careerService.sec2.ben1.title': 'Work in a Language Academy',
  'careerService.sec2.ben1.text':
    'Teach English to adults or children in top language academies and ESL schools here in Barcelona, or elsewhere in the world.',
  'careerService.sec2.ben2.title': ' Teach Business Classes',
  'careerService.sec2.ben2.text':
    'English is the language of international business, which has created work providing in-house instruction to business employees.',
  'careerService.sec2.ben3.title': 'Tutor or Teach Privately',
  'careerService.sec2.ben3.text':
    'Set your own schedule as a professional English teacher focused on adults, school children, teenagers, or immigrants.',
  'careerService.sec2.ben4.title': 'Find Work Online',
  'careerService.sec2.ben4.text':
    'Thanks to the wonders of the world wide web, millions of potential students are just a few clicks away.',
  'careerService.sec2.ben5.title': '98%',
  'careerService.sec2.ben5.text': 'Total passing rate of all TEFL students since 2012.',
  'careerService.sec2.ben6.title': '1500€',
  'careerService.sec2.ben6.text': 'Average monthly income for new English teachers.',
  'careerService.sec2.ben7.title': '2 weeks',
  'careerService.sec2.ben7.text': 'Average time it takes for course graduates to find work.',
  'careerService.sec3.title': 'Find Your Dream Job With TEFL Iberia',
  'careerService.sec3.description':
    'Here at TEFL Iberia, we do more than just equip you with an industry-leading education in teaching English, accredited by Trinity College London. We also equip you with the skills, guidance, and connections you need to find paying work within weeks of completing your coursework.',
  'careerService.sec3.benefitsTitle': 'Our post-course preparation and support includes:',
  'careerService.sec3.ben1': 'Job market orientation session.',
  'careerService.sec3.ben2': 'CV preparation workshop.',
  'careerService.sec3.ben3': 'Interview prep and practice.',
  'careerService.sec3.ben4': 'Exclusive access to our employer database.',
  'careerService.sec3.ben5': 'Insider access to the TEFL Iberia job board.',
  'careerService.sec4.title': 'Recent TEFL Iberia Graduates Work At:',
  'careerService.sec7.title':
    ' Ready to Take the First Steps Towards <accent>Your New Career?</accent>',
  'careerService.sec7.description':
    'It’s now easier than ever to become an international English teacher. Apply now and start working towards your own dream job today.',
  'careerService.graduates.title':
    'We have helped hundreds of students get certified and find work in Spain. Do you want to be the next one?',
};

export default translations;
